export const LatitudeValidator = (value) => {
  return !isNaN(parseFloat(value)) && value >= -90 && value <= 90;
}

export const LongitudeValidator = (value) => {
  return !isNaN(parseFloat(value)) && value >= -180 && value <= 180;
}

export const NumberValidator = (value, component) => {
  return !isNaN(parseFloat(value)) && isFinite(value);
}



// WEBPACK FOOTER //
// ./src/helpers/validators/simple-validators.js